import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`All the `}<a parentName="p" {...{
        "href": "/react-sim/api/#canvasframe"
      }}>{`CanvasFrame`}</a>{` properties, plus:`}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Name`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td">{`canvas`}</strong><br />{`DOM Node`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The actual canvas node`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td">{`ctx`}</strong><br />{`Canvas rendering context`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`the corresponding 2d context.`}<br />{`Exactly what you'd get if you typed`}<br />{` `}<inlineCode parentName="td">{`const ctx = canvas.getContext('2d');`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td">{`circle`}</strong><br />{`Helper function`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`see `}<a parentName="td" {...{
              "href": "/react-sim/api#circle"
            }}>{`circle API`}</a></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td">{`roundRectangle`}</strong><br />{`Helper function`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`see `}<a parentName="td" {...{
              "href": "/react-sim/api#roundrectangle"
            }}>{`roundRectangle API`}</a></td>
        </tr>
      </tbody>
    </table>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      